/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../../../../../../omg/fulfillment/fulfillment';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "kds": {
                            "nested": {
                              "KDSUISettings": {
                                "fields": {
                                  "timerSettings": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.TimerSetting",
                                    "id": 1,
                                    "rule": "repeated"
                                  },
                                  "layouts": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Layout",
                                    "id": 2,
                                    "rule": "repeated"
                                  },
                                  "textSize": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.TextSize",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": "MEDIUM"
                                    }
                                  },
                                  "sounds": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Sound",
                                    "id": 4,
                                    "rule": "repeated"
                                  },
                                  "columns": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Columns",
                                    "id": 5,
                                    "rule": "optional",
                                    "options": {
                                      "default": "FIVE"
                                    }
                                  },
                                  "ticketLayoutSetting": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.TicketLayoutSetting",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "TimerSetting": {
                                    "fields": {
                                      "timerEnabled": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "fireInterval": {
                                        "type": "uint32",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "timerType": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.TimerSetting.TimerType",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "colorHexValue": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                      }
                                    },
                                    "nested": {
                                      "TimerType": {
                                        "values": {
                                          "TIMER_TYPE_DO_NOT_USE": 0,
                                          "WARN": 1,
                                          "ALERT": 2
                                        }
                                      }
                                    }
                                  },
                                  "Layout": {
                                    "fields": {
                                      "layoutType": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Layout.LayoutType",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "selected": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    },
                                    "nested": {
                                      "LayoutType": {
                                        "values": {
                                          "LAYOUT_TYPE_DO_NOT_USE": 0,
                                          "ONE_RAIL": 1,
                                          "TWO_RAILS": 2,
                                          "THREE_RAILS": 3,
                                          "FLEX_RAIL": 4,
                                          "TILE_FILL": 5
                                        }
                                      }
                                    }
                                  },
                                  "TextSize": {
                                    "values": {
                                      "TEXT_SIZE_DO_NOT_USE": 0,
                                      "SMALL": 1,
                                      "MEDIUM": 2,
                                      "LARGE": 3
                                    }
                                  },
                                  "Sound": {
                                    "fields": {
                                      "soundType": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Sound.SoundType",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "enabled": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    },
                                    "nested": {
                                      "SoundType": {
                                        "values": {
                                          "SOUND_DO_NOT_USE": 0,
                                          "NEW_TICKET": 1
                                        }
                                      }
                                    }
                                  },
                                  "Columns": {
                                    "values": {
                                      "COLUMNS_DO_NOT_USE": 0,
                                      "FOUR": 4,
                                      "FIVE": 5,
                                      "SIX": 6
                                    }
                                  },
                                  "TicketLayoutSetting": {
                                    "fields": {
                                      "headerType": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.ChitHeaderType",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": "CONDENSED"
                                        }
                                      },
                                      "customizeDiningOptionsEnabled": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      },
                                      "diningOptionColorConfiguration": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.DiningOptionColorConfiguration",
                                        "id": 3,
                                        "rule": "repeated"
                                      },
                                      "fulfillmentTypeColorConfiguration": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.FulfillmentTypeColorConfiguration",
                                        "id": 4,
                                        "rule": "repeated"
                                      }
                                    }
                                  },
                                  "ChitHeaderType": {
                                    "values": {
                                      "CHIT_HEADER_TYPE_DO_NOT_USE": 0,
                                      "CONDENSED": 1,
                                      "FULFILLMENT_FOCUSED": 2
                                    }
                                  },
                                  "DiningOptionColorConfiguration": {
                                    "fields": {
                                      "color": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.ChitHeaderColor",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": "DEFAULT"
                                        }
                                      },
                                      "diningOptionId": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "FulfillmentTypeColorConfiguration": {
                                    "fields": {
                                      "color": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.ChitHeaderColor",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": "DEFAULT"
                                        }
                                      },
                                      "fulfillmentType": {
                                        "type": "squareup.omg.fulfillment.FulfillmentType",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "ChitHeaderColor": {
                                    "values": {
                                      "CHIT_HEADER_COLOR_DO_NOT_USE": 0,
                                      "DEFAULT": 1,
                                      "WHITE": 2,
                                      "BLUE": 3,
                                      "PURPLE": 4,
                                      "SAND": 5,
                                      "TEAL": 6
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.TimerSetting && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.TimerSetting?.nested?.TimerType && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.Layout && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.Layout?.nested?.LayoutType && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.TextSize && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.Sound && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.Sound?.nested?.SoundType && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.Columns && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.TicketLayoutSetting && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.ChitHeaderType && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.DiningOptionColorConfiguration && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.FulfillmentTypeColorConfiguration && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSUISettings?.nested?.ChitHeaderColor) {
  $root.addJSON(jsonData);
}

/**
 * The settings for displaying chits on the KDS
 *
 * SOURCE KDSUISettings @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 12:1
 */
export const KDSUISettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings');
fixType(KDSUISettings);
Builder.createAndAttachToType(KDSUISettings);
/**
 * SOURCE TimerSetting @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 17:3
 */
KDSUISettings.TimerSetting = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.TimerSetting');
fixType(KDSUISettings.TimerSetting);
Builder.createAndAttachToType(KDSUISettings.TimerSetting);
/**
 * SOURCE TimerType @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 24:5
 */
KDSUISettings.TimerSetting.TimerType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.TimerSetting.TimerType').values;
/**
 * SOURCE Layout @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 34:3
 */
KDSUISettings.Layout = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Layout');
fixType(KDSUISettings.Layout);
Builder.createAndAttachToType(KDSUISettings.Layout);
/**
 * SOURCE LayoutType @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 40:5
 */
KDSUISettings.Layout.LayoutType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Layout.LayoutType').values;
/**
 * SOURCE TextSize @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 53:3
 */
KDSUISettings.TextSize = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.TextSize').values;
/**
 * SOURCE Sound @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 63:3
 */
KDSUISettings.Sound = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Sound');
fixType(KDSUISettings.Sound);
Builder.createAndAttachToType(KDSUISettings.Sound);
/**
 * SOURCE SoundType @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 69:5
 */
KDSUISettings.Sound.SoundType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Sound.SoundType').values;
/**
 * SOURCE Columns @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 78:3
 */
KDSUISettings.Columns = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.Columns').values;
/**
 * SOURCE TicketLayoutSetting @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 90:3
 */
KDSUISettings.TicketLayoutSetting = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.TicketLayoutSetting');
fixType(KDSUISettings.TicketLayoutSetting);
Builder.createAndAttachToType(KDSUISettings.TicketLayoutSetting);
/**
 * SOURCE ChitHeaderType @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 101:3
 */
KDSUISettings.ChitHeaderType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.ChitHeaderType').values;
/**
 * SOURCE DiningOptionColorConfiguration @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 107:3
 */
KDSUISettings.DiningOptionColorConfiguration = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.DiningOptionColorConfiguration');
fixType(KDSUISettings.DiningOptionColorConfiguration);
Builder.createAndAttachToType(KDSUISettings.DiningOptionColorConfiguration);
/**
 * SOURCE FulfillmentTypeColorConfiguration @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 112:3
 */
KDSUISettings.FulfillmentTypeColorConfiguration = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.FulfillmentTypeColorConfiguration');
fixType(KDSUISettings.FulfillmentTypeColorConfiguration);
Builder.createAndAttachToType(KDSUISettings.FulfillmentTypeColorConfiguration);
/**
 * SOURCE ChitHeaderColor @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_ui_settings.proto at 117:3
 */
KDSUISettings.ChitHeaderColor = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings.ChitHeaderColor').values;